export const totalTheme = (array, key) => {
    if (array.length > 0) {
        const arr = array.map(a => a[key]);
        return arr.reduce((a, b) => (a - 0) + (b - 0));
    }
    return 0;
}

export const finishedTheme = (array) => {
    let i = 0;
    array.forEach(element => {
        if (element.knowledgeStudyedNumber === element.totalNumber) {
            i++
        }
    });
    return i
}